import { useState, useEffect } from 'react';
import { MantineProvider, Text, TextInput, Textarea, Box, Button, Checkbox, Switch, Radio, Group, SimpleGrid, Stepper, rem, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { DateInput } from '@mantine/dates';
import { API } from '../classes/API';
import { type } from 'os';
import { notifications } from '@mantine/notifications';
import { IconAlertCircle } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export default function AppointmentForm(props:appointmentFormProps) {
    const [active, setActive] = useState(0);
    const [childCount, setChildCount] = useState(1);
    const [highestStepVisited, setHighestStepVisited] = useState(active);
    const [nextButton, setNextButton] = useState('');
    const [formSent, setFormSent] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const navigate = useNavigate();

    const form = useForm({
      validateInputOnBlur: true,
      initialValues: {
        parentFirstName: '',
        parentLastName: '',
        parentPronoun: '',
        appointment: {
          partnerFirstName: '',
          partnerLastName: '',
          gpAddress1: '',
          gpAddress2: '',
          gpCity: '',
          gpCounty: '',
          gpPostcode: '',
          bloodClotting: '',
          babyMedicalTreatment: '',
          previouslyBreastFed:'',

          feedingWorries: '',
          pregnancyIssues: '',
          birthDescription: '',
          medication: '',
          // TODO this is duplicated??
          healthConcerns: '',
          mentalHalthConcerns: '',
          pumpConfirmation: '',
          ibclcContactMidwife: '',
          ibclcShareSummary: '',
          ibclcShareMedia: '',
          noDogsDuringVisit: '',
          howDidYouHearAboutLWBF: '',
          parkingIssues: '',
          weeksBabyBorn: '',
          nicu: '',
          babyMedication: '',
          receivedAdvice: '',

          feedingBreastMilk: false,
          feedingExpressedBreastMilk: false,
          feedingFormulaMilk: false,
          feedingDonorMilk: false,
          feedingSolidFood: false,

          feedingHelpNippleShields: false,
          feedingHelpBottles: false,
          feedingHelpDummy: false,
          feedingHelpSNS: false,
          feedingHelpCup: false,
          feedingHelpFingerFeeding: false,
          // niceDateOfAppointment: '',
          // dateOfAppointment: '',
          unavailability: '',
        },
        dateOfBirthObj: null as Date | null,
        dateOfBirth: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        county: '',
        postcode: '',
        phoneNumber: '',
        // babyDateOfBirth: '',
        namedMidwife: '',
        namedHealthVisitor: '',
        // FIXME - not set anywhere
        // pumpRequest: false,
        children: [
          {
            firstName:'',
            lastName:'',
            dateOfBirthObj: null as Date | null,
            dateOfBirth:'',
            nhs:'',
            vitaminK:null,
            weights: [
              {
                weight:0,
                date:'',
                dateObj: null as Date | null,
              },
              {
                weight:0,
                date:'',
                dateObj: null as Date | null,
              },
              {
                weight:0,
                date:'',
                dateObj: null as Date | null,
              },
              {
                weight:0,
                date:'',
                dateObj: null as Date | null,
              },
              {
                weight:0,
                date:'',
                dateObj: null as Date | null,
              },
            ],
          },
        ],
      },

      validate: (values) => {
        if (props.editable) {
        if (active === 0) {
          let parentFirstNameError = null
          if (values.parentFirstName.trim().length < 2) {
            parentFirstNameError = 'First name must include at least 2 characters'
          } else if (values.parentFirstName.trim().length > 250) {
            parentFirstNameError = 'First name must be less than 250 characters'
          }
          let parentLastNameError = null
          if (values.parentLastName.trim().length < 2) {
            parentLastNameError = 'Last name must include at least 2 characters'
          } else if (values.parentLastName.trim().length > 250) {
            parentLastNameError = 'Last name must be less than 250 characters'
          }
          let pronounError = null
          if (values.parentPronoun.trim().length > 50) {
            pronounError = 'Pronoun must be less than 50 characters'
          }
          let emailError = null
          if (values.email.trim().length < 2) {
            emailError = 'Email must include at least 2 characters'
          } else if (values.email.trim().length > 150) {
            emailError = 'Email must be less than 150 characters'
          }
          let address1Error = null
          if (values.address1.trim().length < 2) {
            address1Error = 'Address 1 must include at least 2 characters'
          } else if (values.address1.trim().length > 150) {
            address1Error = 'Address 1 must be less than 150 characters'
          }
          let address2Error = null
          if (values.address2.trim().length > 150) {
            address2Error = 'Address 2 must be less than 150 characters'
          }
          let cityError = null
          if (values.city.trim().length < 2) {
            cityError = 'Please enter your town/city'
          } else if (values.city.trim().length > 150) {
            cityError = 'Town/City must be less than 50 characters'
          }
          let countyError = null
          if (values.county.trim().length < 2) {
            countyError = 'Please enter your county'
          } else if (values.county.trim().length > 150) {
            countyError = 'County must be less than 50 characters'
          }
          let postcodeError = null
          if (values.postcode.trim().length < 2) {
            postcodeError = 'Please enter your postcode'
          } else if (values.postcode.trim().length > 16) {
            postcodeError = 'Postcode must be less than 16 characters'
          }
          let phoneNumberError = null
          if (values.phoneNumber.trim().length < 2) {
            phoneNumberError = 'Please enter your phone number'
          } else if (values.phoneNumber.trim().length > 150) {
            phoneNumberError = 'Phone number must be less than 50 characters'
          }
          return {
            parentFirstName: parentFirstNameError,
            parentLastName: parentLastNameError,
            dateOfBirthObj: values.dateOfBirthObj == null ? 'Select a date of birth' : null,
            email: emailError,
            parentPronoun: pronounError,
            address1: address1Error,
            address2: address2Error,
            city: cityError,
            county: countyError,
            postcode: postcodeError,
            phoneNumber: phoneNumberError,
          };
        }

        if (active === 1) {
          const errors:Record<string,any> = {
            'appointment.feedingWorries': values.appointment.feedingWorries.trim().length < 2 ? 'Please fill this in' : null,
          };

          values.children.map((child, ind) => {

            let firstNameError = null
            if (values.children[ind].firstName.trim().length < 2) {
              firstNameError = 'First name must include at least 2 characters'
            } else if (values.children[ind].firstName.trim().length > 150) {
              firstNameError = 'First name must be less than 50 characters'
            }
            let lastNameError = null
            if (values.children[ind].lastName.trim().length < 2) {
              lastNameError = 'Last name must include at least 2 characters'
            } else if (values.children[ind].lastName.trim().length > 150) {
              lastNameError = 'Last name must be less than 50 characters'
            }
            let nhsError = null
            if (values.children[ind].nhs.trim().length < 2) {
              nhsError = 'Please enter the NHS Number/Hospital Number'
            } else if (values.children[ind].nhs.trim().length > 150) {
              nhsError = 'NHS number must be less than 100 characters'
            }

            errors['children.'+ind+'.firstName'] = firstNameError
            errors['children.'+ind+'.lastName'] = lastNameError
            errors['children.'+ind+'.dateOfBirthObj'] = values.children[ind].dateOfBirthObj == null ? 'Select a date of birth' : null
            errors['children.'+ind+'.nhs'] = nhsError
            errors['children.'+ind+'.vitaminK'] = values.children[ind].vitaminK == undefined ? 'Please select if the baby has received Vitamin K' : null

            let i = 0
            for (i = 0; i < 5; i++) {
              if (values.children[ind].weights[i].weight && Number.isNaN(Number(values.children[ind].weights[i].weight))) {
                errors['children.'+ind+'.weights.'+i+'.weight'] = 'Weight must be a number';
              }
            }
          })

          return errors
        }

        if (active === 2) {


          let gpAddress1Error = null
          if (values.appointment.gpAddress1.trim().length < 2) {
            gpAddress1Error = 'Address line 1 must include at least 2 characters'
          } else if (values.appointment.gpAddress1.trim().length > 150) {
            gpAddress1Error = 'Address line 1 must be less than 500 characters'
          }
          let gpAddress2Error = null
          if (values.appointment.gpAddress2.trim().length > 150) {
            gpAddress2Error = 'Address line 2 must be less than 500 characters'
          }
          let gpCityError = null
          if (values.appointment.gpCity.trim().length < 2) {
            gpCityError = 'City must include at least 2 characters'
          } else if (values.appointment.gpCity.trim().length > 150) {
            gpCityError = 'City must be less than 200 characters'
          }
          let gpCountyError = null
          if (values.appointment.gpCounty.trim().length < 2) {
            gpCountyError = 'County must include at least 2 characters'
          } else if (values.appointment.gpCounty.trim().length > 150) {
            gpCountyError = 'County must be less than 200 characters'
          }
          let gpPostcodeError = null
          if (values.appointment.gpPostcode.trim().length < 2) {
            gpPostcodeError = 'Postcode must include at least 2 characters'
          } else if (values.appointment.gpPostcode.trim().length > 16) {
            gpPostcodeError = 'Postcode must be less than 16 characters'
          }
          let namedMidwifeError = null
          if (values.namedMidwife.trim().length < 2) {
            namedMidwifeError = 'Named midwife must include at least 2 characters'
          } else if (values.namedMidwife.trim().length > 250) {
            namedMidwifeError = 'Named midwife must be less than 200 characters'
          }

          return {
            'appointment.gpAddress1': gpAddress1Error,
            'appointment.gpAddress2': gpAddress2Error,
            'appointment.gpCity': gpCityError,
            'appointment.gpCounty': gpCountyError,
            'appointment.gpPostcode': gpPostcodeError,
            'namedMidwife': namedMidwifeError,
            'appointment.bloodClotting': values.appointment.bloodClotting.trim().length < 2 ? 'This must include at least 2 characters' : null,
            'appointment.babyMedicalTreatment': values.appointment.babyMedicalTreatment.trim().length < 2 ? 'This must include at least 2 characters' : null,
          };
        }

        if (active === 3) {
          return {
            'appointment.healthConcerns' : values.appointment.healthConcerns.trim().length < 2 ? 'Please select if there are any health concerns' : null,
            'appointment.pumpConfirmation' : values.appointment.pumpConfirmation.trim().length < 2 ? 'Please select an option' : null,
            'appointment.ibclcContactMidwife' : values.appointment.ibclcContactMidwife.trim().length < 2 ? 'Please select an option' : null,
            'appointment.ibclcShareSummary' : values.appointment.ibclcShareSummary.trim().length < 2 ? 'Please select an option' : null,
            'appointment.noDogsDuringVisit' : values.appointment.noDogsDuringVisit != "true" ? 'You must consent to this' : null,
          };
        }
      }
        return {};
      },
    });

    const handleStepChange = (nextStep: number) => {
      const isOutOfBounds = nextStep > 4 || nextStep < 0;

      const hasErrors = form.validate().hasErrors;
      if (hasErrors) {
        // Failed
        notifications.show({
          id:'setUser',
          color: 'red',
          message: 'There are some errors in the form, please correct them',
          icon: <IconAlertCircle style={{ width: rem(18), height: rem(18) }} />,
          loading: false,
          autoClose: 5000,
        });
      }

      if (isOutOfBounds || hasErrors) {
        return;
      }
      setActive(nextStep);
      setHighestStepVisited((hSC) => Math.max(hSC, nextStep));
      window.scrollTo(0, 0)
    };

   // Allow the user to freely go back and forth between visited steps.
   // TODO add error checking here
   const shouldAllowSelectStep = (step: number) => highestStepVisited >= step && active !== step; //&& !form.validate().hasErrors;

    const formValues = {}





    useEffect(
      () => {
        if (props.data !== undefined && form.values.parentFirstName == '') {
          form.setValues(props.data as Object)
          var milliseconds = Date.parse(props.data.dateOfBirth);
          var date = new Date(milliseconds);
          form.setFieldValue('dateOfBirthObj',date)
          setHighestStepVisited(4)
          props.data.children.forEach((c,i) => {
            milliseconds = Date.parse(c.dateOfBirth);
            date = new Date(milliseconds);
            form.setFieldValue(`children.${i}.dateOfBirthObj`,date)
            c.weights.forEach((w, wi) => {
              milliseconds = Date.parse(w.date);
              date = new Date(milliseconds);
              form.setFieldValue(`children.${i}.weights.${wi}.dateObj`,date)
            })
          })
        }
      },
      [form]
    )



    const babies = form.values.children.map((_, index) => (
      <>
        <p>Baby name*</p>
        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <TextInput
            id="baby-first-name"
            aria-label="First Name"
            placeholder="First Name"
            type="input"
            name={`baby_${index}_first_name`}
            {...form.getInputProps(`children.${index}.firstName`)}
            readOnly={!props.editable}
          />

          <TextInput
            aria-label="Last Name"
            placeholder="Last Name"
            type="input"
            {...form.getInputProps(`children.${index}.lastName`)}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <DateInput
            label="Baby Date of Birth"
            placeholder="Baby Date of Birth"
            //maw={400}
            //mx="auto"
            {...form.getInputProps(`children.${index}.dateOfBirthObj`)}
            my="md"
            required={true}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <p>Please give us a list of weights for baby:</p>

        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <DateInput
            // label="Date"
            placeholder="Date"
            {...form.getInputProps(`children.${index}.weights.0.dateObj`)}
            my="md"
            readOnly={!props.editable}
          />
          <TextInput
            placeholder="Weight"
            type="input"
            my="md"
            rightSection="kg"
            {...form.getInputProps(`children.${index}.weights.0.weight`)}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <DateInput
            placeholder="Date"
            {...form.getInputProps(`children.${index}.weights.1.dateObj`)}
            my="md"
            readOnly={!props.editable}
          />
          <TextInput
            placeholder="Weight"
            type="input"
            my="md"
            rightSection="kg"
            {...form.getInputProps(`children.${index}.weights.1.weight`)}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <DateInput
            placeholder="Date"
            {...form.getInputProps(`children.${index}.weights.2.dateObj`)}
            readOnly={!props.editable}
            my="md"
          />
          <TextInput
            placeholder="Weight"
            type="input"
            my="md"
            rightSection="kg"
            {...form.getInputProps(`children.${index}.weights.2.weight`)}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <DateInput
            placeholder="Date"
            {...form.getInputProps(`children.${index}.weights.3.dateObj`)}
            readOnly={!props.editable}
            my="md"
          />
          <TextInput
            placeholder="Weight"
            type="input"
            my="md"
            rightSection="kg"
            {...form.getInputProps(`children.${index}.weights.3.weight`)}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
          <DateInput
            placeholder="Date"
            {...form.getInputProps(`children.${index}.weights.4.dateObj`)}
            readOnly={!props.editable}
            my="md"
          />
          <TextInput
            placeholder="Weight"
            type="input"
            my="md"
            rightSection="kg"
            {...form.getInputProps(`children.${index}.weights.4.weight`)}
            readOnly={!props.editable}
          />
        </SimpleGrid>

        <TextInput
          label="Baby NHS Number/Hospital Number"
          aria-label="Baby NHS Number/Hospital Number"
          placeholder=""
          type="text"
          required={true}
          my="md"
          {...form.getInputProps(`children.${index}.nhs`)}
          readOnly={!props.editable}
          />

        <Radio.Group
          {...form.getInputProps(`children.${index}.vitaminK`)}
          label="Has Baby had Vitamin K injection or 2 doses of Oral vitamin K"
          //description="This is anonymous"
          withAsterisk
            my="md"
            // value={`${form.values.children[index].vitaminK}`}
            // onChange={
            //   (e) => {
            //     if (props.editable) {
            //       form.getInputProps(`children.${index}.vitaminK`).onChange(e)
            //     }
            //   }
            // }
        >
          <Group mt="xs">
            <Radio value="true" label="Yes"
            readOnly={!props.editable}
/>
            <Radio value="false" label="No"
            readOnly={!props.editable}
/>
          </Group>
        </Radio.Group>
      </>
    ));







    return (
        <>
      <Text ta="center">
        <h1>Book an appointment</h1>
      </Text>
      <form onSubmit={form.onSubmit(
        (values, _event) => {

          if (props.editable) {


          const parentDOB = values.dateOfBirthObj
          if (parentDOB != null) {
            values.dateOfBirth = parentDOB.getFullYear()+'-'+(parentDOB.getMonth()+1)+'-'+parentDOB.getDate()
          }
          // const appointmentDate = new Date(values.appointment.niceDateOfAppointment)
          // values.appointment.dateOfAppointment = appointmentDate.getFullYear()+'-'+(appointmentDate.getMonth()+1)+'-'+appointmentDate.getDate()+' 00:00:00'

          for(let i=0; i<values.children.length;i++){
            const tmpDate = values.children[i].dateOfBirthObj
            if (tmpDate != null) {
              values.children[i].dateOfBirth = tmpDate.getFullYear()+'-'+(tmpDate.getMonth()+1)+'-'+tmpDate.getDate()
            }
            // values.babyFirstName[i] = values.babies[i].firstName
            // values[`babyFirstName1`] = values.babies[i].firstName
          }

          var temp = null
          var babycount = values.children.length
          for (var i = 0; i < babycount; i++) {
            for (var j = 0; j < values.children[i].weights.length; j++) {

              // if (values.children[i].weights[j].date != '') {
                temp = values.children[i].weights[j].dateObj
                if (temp != null) {
                  values.children[i].weights[j].date = temp.getFullYear()+'-'+(temp.getMonth()+1)+'-'+temp.getDate()
                }
              // } else {
              //   values.children[i].weights[j].date = '';
              //   values.children[i].weights[j].niceDate = new Date;
              // }
            }
          }
          console.log('vals',values);
          setSubmitLoading(true)
          API.post('/appointment',values).then((response) =>{
            console.log('submit response', response)
            if (response.status === 201) {

              navigate('/appointment/confirmation');


              // setFormSent(true)
              // setSubmitLoading(false)
            } else {
              // Failed
              notifications.show({
                id:'setUser',
                color: 'red',
                message: 'Error saving the appointment',
                icon: <IconAlertCircle style={{ width: rem(18), height: rem(18) }} />,
                loading: false,
                autoClose: 2000,
              });
              setSubmitLoading(false)
            }
          })


        }

        },
        (validationErrors, _values, _event) => {
          console.log('ERRORS',validationErrors)
          console.log('FORM VALS',_values)
        }
      )}>

        <Stepper active={active} onStepClick={setActive} breakpoint="sm">
          <Stepper.Step
            label="About you"
            description=""
            allowStepSelect={shouldAllowSelectStep(0)}
          >
            <h2>About you</h2>
            <p>Parent's full name</p>
            <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
              <TextInput
                id="parent-first-name"
                aria-label="First Name"
                placeholder="First Name"
                type="input"
                name="parent-first-name"
                // disabled={!props.editable}
                {...form.getInputProps('parentFirstName')}
                readOnly={!props.editable}
              />
              <TextInput
                id="parent-last-name"
                aria-label="Last Name"
                placeholder="Last Name"
                type="input"
                name="parent-last-name"
                {...form.getInputProps('parentLastName')}
                readOnly={!props.editable}
              />
            </SimpleGrid>
            <TextInput
              id="parent-pronoun"
              aria-label="Pronoun"
              placeholder="Pronoun"
              type="input"
              name="parent-pronoun"
              {...form.getInputProps('parentPronoun')}
              readOnly={!props.editable}

            />

            <p>Partner's full name</p>
            <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
              <TextInput
                id="partner-first-name"
                aria-label="First Name"
                placeholder="First Name"
                type="input"
                name="partner-first-name"
                {...form.getInputProps('appointment.partnerFirstName')}
                readOnly={!props.editable}
              />

              <TextInput
                id="partner-last-name"
                aria-label="Last Name"
                placeholder="Last Name"
                type="input"
                name="partner-last-name"
                {...form.getInputProps('appointment.partnerLastName')}
                readOnly={!props.editable}
              />
            </SimpleGrid>

            <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]} my="md">
              <DateInput
                label="Breastfeeding parents date of birth"
                placeholder="Breastfeeding parents date of birth"
                required={true}
                // maw={400}
                // mx="auto"
                {...form.getInputProps('dateOfBirthObj')}
                readOnly={!props.editable}
              />
            </SimpleGrid>

            <TextInput
              label="Email Address"
              aria-label="Email Address"
              placeholder="example@example.com"
              type="email"
              {...form.getInputProps('email')}
              my="md"
              readOnly={!props.editable}
            />

            <p>Address</p>
            <TextInput
              aria-label="Address Line 1"
              placeholder="Address Line 1"
              type="text"
              required={true}
              {...form.getInputProps('address1')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="Address Line 2"
              placeholder="Address Line 2"
              type="text"
              {...form.getInputProps('address2')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="Town/City"
              placeholder="Town/City"
              type="text"
              required={true}
              {...form.getInputProps('city')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="County"
              placeholder="County"
              type="text"
              {...form.getInputProps('county')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="Postcode"
              placeholder="Postcode"
              type="text"
              required={true}
              {...form.getInputProps('postcode')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="Phone Number"
              placeholder="Phone Number"
              type="text"
              {...form.getInputProps('phoneNumber')}
              readOnly={!props.editable}
            />
            <Textarea
              label="Are there any parking issues or restrictions?"
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.parkingIssues')}
              readOnly={!props.editable}
            />
          </Stepper.Step>
          <Stepper.Step
            label="About baby"
            description=""
            allowStepSelect={shouldAllowSelectStep(1)}
          >
            <h2>About baby</h2>
            {babies}
            {form.values.children.length < 3 && props.editable &&
              <Group position="center" mt="md">
                <Button onClick={() => {
                  form.insertListItem(
                    'children',
                    {
                      firstName:'',
                      lastName:'',
                      dateOfBirth:'',
                      nhs:'',
                      vitaminK:null,
                      weights: [
                        {
                          weight:0,
                          date:'',
                          niceDate:new Date,
                        },
                        {
                          weight:0,
                          date:'',
                          niceDate:new Date,
                        },
                        {
                          weight:0,
                          date:'',
                          niceDate:new Date,
                        },
                        {
                          weight:0,
                          date:'',
                          niceDate:new Date,
                        },
                        {
                          weight:0,
                          date:'',
                          niceDate:new Date,
                        },
                      ],
                    }
                  )
                }}>
                  Add additional baby
                </Button>
              </Group>
            }


            <p>What are you currently feeding baby?</p>
            <Checkbox
              label="Breastmilk"
              my="xs"
              {...form.getInputProps('appointment.feedingBreastMilk', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingBreastMilk`).onChange(e)
              //     }
              //   }
              // }

              value={`${form.values.appointment.feedingBreastMilk}`}
            />
            <Checkbox
              label="Expressed breastmilk"
              my="xs"
              {...form.getInputProps('appointment.feedingExpressedBreastMilk', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingExpressedBreastMilk`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Formula milk"
              my="xs"
              {...form.getInputProps('appointment.feedingFormulaMilk', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingFormulaMilk`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Donor milk"
              my="xs"
              {...form.getInputProps('appointment.feedingDonorMilk', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingDonorMilk`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Solid food"
              my="xs"
              {...form.getInputProps('appointment.feedingSolidFood', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingSolidFood`).onChange(e)
              //     }
              //   }
              // }
            />

            <p>Are you currently using anything to help you with feeding baby?</p>
            <Checkbox
              label="Nipple shields"
              my="xs"
              {...form.getInputProps('appointment.feedingHelpNippleShields', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingHelpNippleShields`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Bottles"
              my="xs"
              {...form.getInputProps('appointment.feedingHelpBottles', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingHelpBottles`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Dummy"
              my="xs"
              {...form.getInputProps('appointment.feedingHelpDummy', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingHelpDummy`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="SNS"
              my="xs"
              {...form.getInputProps('appointment.feedingHelpSNS', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingHelpSNS`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Cup"
              my="xs"
              {...form.getInputProps('appointment.feedingHelpCup', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingHelpCup`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Finger feeding"
              my="xs"
              {...form.getInputProps('appointment.feedingHelpFingerFeeding', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.feedingHelpFingerFeeding`).onChange(e)
              //     }
              //   }
              // }
            />

            <Textarea
              label="Please tell us what is worrying you about feeding?"
              aria-label="Please tell us what is worrying you about feeding?"
              placeholder=""
              required={true}
              my="md"
              {...form.getInputProps('appointment.feedingWorries')}
              readOnly={!props.editable}
            />
            <TextInput
              label="How many weeks was your baby when they were born?"
              aria-label="How many weeks was your baby when they were born?"
              placeholder=""
              type="text"
              my="md"
              {...form.getInputProps('appointment.weeksBabyBorn')}
              readOnly={!props.editable}
            />

          </Stepper.Step>
          <Stepper.Step
            label="Medical"
            description=""
            allowStepSelect={shouldAllowSelectStep(2)}
          >
            <h2>Medical details</h2>
            <p>GP Surgery Name and Address*</p>
            <TextInput
              aria-label="Address line 1"
              placeholder="Address line 1"
              type="text"
              my="md"
              {...form.getInputProps('appointment.gpAddress1')}
              readOnly={!props.editable}
            />
            <TextInput
              my="md"
              aria-label="Address line 2"
              placeholder="Address line 2"
              type="text"
              {...form.getInputProps('appointment.gpAddress2')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="Town/City"
              placeholder="Town/City"
              type="text"
              my="md"
              {...form.getInputProps('appointment.gpCity')}
              readOnly={!props.editable}
            />
            <TextInput
              aria-label="County"
              placeholder="County"
              type="text"
              my="md"
              {...form.getInputProps('appointment.gpCounty')}
              readOnly={!props.editable}
              />
            <TextInput
              aria-label="Postcode"
              placeholder="Postcode"
              type="text"
              my="md"
              {...form.getInputProps('appointment.gpPostcode')}
              readOnly={!props.editable}
            />


            <TextInput
              label="Named midwife and team"
              aria-label="Named midwife and team"
              placeholder=""
              type="text"
              required={true}
              my="md"
              {...form.getInputProps('namedMidwife')}
              readOnly={!props.editable}
            />
            <TextInput
              label="Named Health visitor"
              aria-label="Named Health visitor"
              placeholder=""
              type="text"
              my="md"
              {...form.getInputProps('namedHealthVisitor')}
              readOnly={!props.editable}
            />
            <TextInput
              label="Is there any history of blood clotting disorders in the family?"
              aria-label="Is there any history of blood clotting disorders in the family?"
              placeholder=""
              type="text"
              my="md"
              required={true}
              {...form.getInputProps('appointment.bloodClotting')}
              readOnly={!props.editable}
            />
            <TextInput
              label="Is baby undergoing any medical treatment or requiring any follow ups"
              aria-label="Is baby undergoing any medical treatment or requiring any follow ups"
              placeholder=""
              type="text"
              my="md"
              required={true}
              {...form.getInputProps('appointment.babyMedicalTreatment')}
              readOnly={!props.editable}
            />

            <TextInput
              label="Did you have any issues in your pregnancy?"
              aria-label="Did you have any issues in your pregnancy?"
              placeholder=""
              type="text"
              my="md"
              {...form.getInputProps('appointment.pregnancyIssues')}
              readOnly={!props.editable}
            />

            <Textarea
              label="Please describe your birth. Were you induced? How long was labour? What type of birth did you have? (Vaginal birth, forceps, ventouse, emergency or elective caesarean)"
              aria-label="Please describe your birth. Were you induced? How long was labour? What type of birth did you have? (Vaginal birth, forceps, ventouse, emergency or elective caesarean)"
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.birthDescription')}
              readOnly={!props.editable}
            />


            <Textarea
              label="Do you take any medication? Do you have any health concerns?"
              aria-label="Do you take any medication? Do you have any health concerns?"
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.medication')}
              readOnly={!props.editable}
            />

            <Textarea
              label="Do you have any mental health concerns (past or/and current)?"
              aria-label="Do you have any mental health concerns (past or/and current)?"
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.mentalHealthConcerns')}
              readOnly={!props.editable}
            />

            <TextInput
              label="If your baby spent any time on NICU then please tell us how long for, and for what reason"
              aria-label="If your baby spent any time on NICU then please tell us how long for, and for what reason"
              placeholder=""
              type="text"
              my="md"
              {...form.getInputProps('appointment.nicu')}
              readOnly={!props.editable}
            />

            <Textarea
              label="Is baby on any medication? Has baby recently taken any medication?"
              aria-label="Is baby on any medication? Has baby recently taken any medication?"
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.babyMedication')}
              readOnly={!props.editable}
            />

          </Stepper.Step>
          <Stepper.Step
            label="Misc"
            description=""
            allowStepSelect={shouldAllowSelectStep(3)}
          >
            <h2>Miscellaneous</h2>

            <p>What is concerning you?</p>
            <Checkbox
              label="Latching baby to breast"
              my="xs"
              {...form.getInputProps('appointment.concernsLatching', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsLatching`).onChange(e)
              //     }
              //   }
              // }
            />
            <Checkbox
              label="Weight gain"
              my="xs"
              {...form.getInputProps('appointment.concernsWeightGain', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsWeightGain`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Tongue tie"
              my="xs"
              {...form.getInputProps('appointment.concernsTongueTie', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsTongueTie`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Milk supply"
              my="xs"
              {...form.getInputProps('appointment.concernsMilkSupply', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsMilkSupply`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Expressing breastmilk"
              my="xs"
              {...form.getInputProps('appointment.concernsExpressingBreastMilk', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsExpressingBreastMilk`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Weaning"
              my="xs"
              {...form.getInputProps('appointment.concernsWeaning', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsWeaning`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Combination feeding"
              my="xs"
              {...form.getInputProps('appointment.concernsCombinationFeeding', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsCombinationFeeding`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Aversion"
              my="xs"
              {...form.getInputProps('appointment.concernsAversion', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsAversion`).onChange(e)
              //     }
              //   }
              // }

            />
            <Checkbox
              label="Breastfeeding grief & trauma from previous baby"
              my="xs"
              {...form.getInputProps('appointment.concernsPreviousBabyTrauma', { type: 'checkbox' })}
              readOnly={!props.editable}
              // onChange={
              //   (e) => {
              //     if (props.editable) {
              //       form.getInputProps(`appointment.concernsPreviousBabyTrauma`).onChange(e)
              //     }
              //   }
              // }

            />

            <Textarea
              label="Have you previously breastfed another child? Please tell us about your experiences."
              aria-label="Have you previously breastfed another child? Please tell us about your experiences."
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.previouslyBreastFed')}
              readOnly={!props.editable}
            />

            <Radio.Group
              name="healthConcerns"
              {...form.getInputProps('appointment.healthConcerns')}
              label="Do you have any immediate concerns about the health of your baby or yourself? If so, please contact your midwife/health visitor/GP immediately."
              withAsterisk
              my="md"
              value={`${form.values.appointment.healthConcerns}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.healthConcerns`).onChange(e)
                  }
                }
              }
            >
              <Group mt="xs">
                <Radio value="true" label="Yes" />
                <Radio value="false" label="No" />
              </Group>
            </Radio.Group>

            <Textarea
              label="What support and advice have you received from your midwife or health visiting team up until this point? Are you on a feeding plan set by the Midwives/Health Visitors or Paediatricians?"
              aria-label="What support and advice have you received from your midwife or health visiting team up until this point? Are you on a feeding plan set by the Midwives/Health Visitors or Paediatricians?"
              placeholder=""
              my="md"
              {...form.getInputProps('appointment.receivedAdvice')}
              readOnly={!props.editable}
            />

            <Radio.Group
              name="breastPump"
              {...form.getInputProps('appointment.pumpConfirmation')}
              label="Do you understand if we loan you a breast pump this loan is for one calendar month? Pumps are required to be returned quickly at the end of the loan to enable us to support more families."
              my="md"
              withAsterisk
              value={`${form.values.appointment.pumpConfirmation}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.pumpConfirmation`).onChange(e)
                  }
                }
              }
            >
              <Group mt="xs">
                <Radio value="true" label="Yes" />
                <Radio value="false" label="No" />
              </Group>
            </Radio.Group>

            <Radio.Group
              name="consentContact"
              {...form.getInputProps('appointment.ibclcContactMidwife')}
              label="Do you give consent for the IBCLC to contact your Midwife/Health Visitor or GP if required"
              my="md"
              withAsterisk
              value={`${form.values.appointment.ibclcContactMidwife}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.ibclcContactMidwife`).onChange(e)
                  }
                }
              }
            >
              <Group mt="xs">
                <Radio value="true" label="Yes" />
                <Radio value="false" label="No" />
              </Group>
            </Radio.Group>

            <Radio.Group
              name="consentSummery"
              {...form.getInputProps('appointment.ibclcShareSummary')}
              label="Do you give your consent for the IBCLC to share their written summary of your appointment to your Midwife/Health Visitor or James Paget University Hospital Infant Feeding Team"
              my="md"
              withAsterisk
              value={`${form.values.appointment.ibclcShareSummary}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.ibclcShareSummary`).onChange(e)
                  }
                }
              }
            >
              <Group mt="xs">
                <Radio value="true" label="Yes" />
                <Radio value="false" label="No" />
              </Group>
            </Radio.Group>
            <Radio.Group
              name="consentShared"
              {...form.getInputProps('appointment.ibclcShareMedia')}
              label="At times IBCLC's will need to ask the opinion of other practitioners. Are you happy for your information, photos and videos to be shared if needed? Personal data will not be shared in this situation"
              my="md"
              value={`${form.values.appointment.ibclcShareMedia}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.ibclcShareMedia`).onChange(e)
                  }
                }
              }
            >
              <Group mt="xs">
                <Radio value="true" label="Yes" />
                <Radio value="false" label="No" />
              </Group>
            </Radio.Group>


            <Radio.Group
              name="noDogsDuringVisit"
              {...form.getInputProps('appointment.noDogsDuringVisit')}
              label="Please note due to previous issues, dogs must be removed from the visit Do you consent?"
              my="md"
              withAsterisk
              value={`${form.values.appointment.noDogsDuringVisit}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.noDogsDuringVisit`).onChange(e)
                  }
                }
              }
            >
              <Group mt="xs">
                <Radio value="true" label="Yes" />
                <Radio value="false" label="No" />
              </Group>
            </Radio.Group>



          </Stepper.Step>

          <Stepper.Completed>
            <h2>Thank you</h2>
            <p>Thanks for filling in the appointment form.</p>
            {
              formSent
              ?
              <p>Your information has been submitted, we'll be in contact soon</p>
              :
              <>
              {/*
                <DateInput
                  label="Please select a preferred date for your appointment"
                  placeholder="Preferred appointment date"
                  required={true}
                  // maw={400}
                  // mx="auto"
                  {...form.getInputProps('appointment.niceDateOfAppointment')}
                />
              */}

                <Textarea
                  label="Do you have any days in the next week you are unavailable?"
                  aria-label="Do you have any days in the next week you are unavailable?"
                  placeholder=""
                  my="md"
                  {...form.getInputProps('appointment.unavailability')}
                  readOnly={!props.editable}
                  />


            <Radio.Group
              name="howDidYouHearAboutLWBF"
              // {...form.getInputProps('appointment.howDidYouHearAboutLWBF')}
              label="How did you hear about LWBF?"
              my="md"
              withAsterisk
              value={`${form.values.appointment.howDidYouHearAboutLWBF}`}
              onChange={
                (e) => {
                  if (props.editable) {
                    form.getInputProps(`appointment.howDidYouHearAboutLWBF`).onChange(e)
                  }
                }
              }
            >
              <Stack mt="xs">
                <Radio value="socialMedia" label="Social media" />
                <Radio value="friendFamily" label="Friend/family" />
                <Radio value="midwife" label="Midwife" />
                <Radio value="tongueTieClinic" label="Tongue Tie Clinic" />
                <Radio value="healthVisitor" label="Health Visitor" />
                <Radio value="neonatalOutreach" label="Neonatal outreach" />
                <Radio value="other" label="Other" />
              </Stack>
            </Radio.Group>


                {props.editable &&
                <>
                  <p>Please press the button below to send us the information.</p>
                  <Button type="submit" size="md" loading={submitLoading}>
                    Book appointment
                  </Button>
                </>
                }
              </>
            }

          </Stepper.Completed>
        </Stepper>

        <Group position="center" mt="xl" mb="md">
          {active > 0 && !formSent ?
          <Button variant="default" onClick={() => handleStepChange(active - 1)}>Back</Button>
          :''
          }
          {active <= 3 ?
          <Button onClick={() => handleStepChange(active + 1)}>Next step</Button>
          :''
          }
        </Group>
        <div id="sidebar">
            <div>
              <div
                id="search-spinner"
                aria-hidden
                hidden={true}
              />
              <div
                className="sr-only"
                aria-live="polite"
              ></div>

          </div>
        </div>
        <div id="detail"></div>
      </form>
        </>
    )
}
